var map = {
	"./de/origin_types": [
		"t4VA",
		53
	],
	"./en/origin_types": [
		"LczF",
		37
	],
	"./fr/origin_types": [
		"0c4v",
		21
	],
	"./nl/origin_types": [
		"KnRx",
		5
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "vEAg";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang lazy ^\.\/.*\/origin_types$
// module id = vEAg
// module chunks = 97